import React from 'react';
import { getForgeIconNameForDisplayType } from 'common/displayTypeMetadata';
import { ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';
import classNames from 'classnames';

import './assetTypeIcon.scss';

interface AssetTypeIconProps {
  displayType: string;
  tooltip?: string;
}

export const AssetTypeIcon = (props: AssetTypeIconProps) => {
  const { displayType, tooltip } = props;
  const name = getForgeIconNameForDisplayType(displayType);

  return (
    <>
      <ForgeIcon name={name} className={classNames('asset-type-icon', displayType)} data-type={displayType} />
      {tooltip && <ForgeTooltip className="asset-type-icon-tooltip">{tooltip}</ForgeTooltip>}
    </>
  );
};
